import { render } from "./FormFooter.vue?vue&type=template&id=549b30d8"
const script = {}

import exportComponent from "C:\\wamp64\\www\\rcpetresort.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__